import { render } from "./HeroiconsSolidArrowCircleRight.vue?vue&type=template&id=1d691bf2"
const script = {}

import exportComponent from "/var/www/web/driving-school-be/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidArrowCircleRight.vue"]])

export default __exports__